<template>
  <div class="container">
    <EmptyDashboard
      v-if="isRequestSuccess && showEmpty"
      :showPayUDialog="showPayUDialog"
      :selectedPortfolio="createdStatePortfolio"
      :accountInfo="accountInfo"
      @closeDialog="closePayUDialog"
    />
    <ConfirmPortfolioSelection
      v-else-if="isRequestSuccess && showConfirmation"
      :accountInfo="accountInfo"
      :selectedPortfolio="createdStatePortfolio"
    />
    <PayUDialog
      v-else-if="isRequestSuccess && showDashboard && showPayUDialog"
      :showPayUDialog="showPayUDialog"
      @closeDialog="closePayUDialog"
    />
    <Dashboard1 v-else-if="isRequestSuccess && showDashboard" />
  </div>
</template>
<script>
import LenderService from '@/services/lenderService'
import EmptyDashboard from '@/components/dashboard/emptyDashboard'
import ConfirmPortfolioSelection from '@/components/dashboard/confirmPortfolio'
import Dashboard1 from '@/components/dashboard/dashboard'
import PayUDialog from '../components/common/paymentComponent/payuDialog.vue'

export default {
    name: 'Dashboard',
    components: {
        EmptyDashboard,
        ConfirmPortfolioSelection,
        Dashboard1,
        PayUDialog
    },
    data () {
        return {
            showEmpty: false,
            showConfirmation: false,
            showDashboard: false,
            isRequestSuccess: true,
            portfolios: [],
            dashboardData: null,
            accountInfo: null,
            portfolioSummary: null,
            createdStatePortfolio: null,
            hideReferralCode: true,
            showPayUDialog: false
        }
    },
    mounted () {
        const isLenderContractSigned = this.$store.state.dashboard.isLenderContractSigned
        if (!isLenderContractSigned) {
            this.$router.replace('/onboarding')
        } else {
            this.getDashboardData()
        }

        if (this.$route.query.showPayUDialog) {
            this.showPayUDialog = true
        }
    },
    methods: {
        closePayUDialog () {
            this.showPayUDialog = false
            this.$router.replace({ query: null })
        },
        async getDashboardData () {
            this.$store.commit('isLoading')
            const response = await Promise.all([
                LenderService.getVirtualAccountInfo(),
                LenderService.getLenderPortfoliosInfo()
            ])
            const accountInfo = response[0]
            const portfolioSummary = response[1]

            if (accountInfo.status === 200) {
                this.accountInfo = accountInfo.data
                this.$store.commit('dashboard/setField', {
                    field: 'accountInfo',
                    value: this.accountInfo
                })
                if (!this.accountInfo.totalAccountValue) {
                    this.showEmpty = true
                }
            }

            if (portfolioSummary.status === 200) {
                this.portfolioSummary = portfolioSummary.data
                this.$store.commit('dashboard/setField', {
                    field: 'portfolioSummary',
                    value: this.portfolioSummary
                })
                const createdPortfolio = this.portfolioSummary.portfolios.filter(
                    (item) => item.status === 0 && item.portfolioType === 'autoInvest'
                )
                if (createdPortfolio.length) {
                    this.createdStatePortfolio = createdPortfolio[0]
                    this.showConfirmation = true
                }
                const paidPortfolios = this.portfolioSummary.portfolios.filter(
                    (item) =>
                        (item.status === 1 || item.pendingInvestmentAmount) &&
            item.portfolioType === 'autoInvest'
                )
                if (paidPortfolios.length) {
                    this.showEmpty = false
                    this.showConfirmation = false
                    this.showDashboard = true
                }
            }
            if (portfolioSummary.status === 401 || accountInfo.status === 401) {
                this.$store.commit('setSessionOver')
            }
            this.isRequestSuccess = true
            this.$store.commit('isNotLoading')
            if (this.showEmpty) {
                this.$store.commit('hideReferralCode', true)
            } else {
                this.$store.commit('hideReferralCode', false)
            }
        }
    }
}
</script>
<style scoped>
.dashboard-container {
  position: relative;
  margin-top: 30px;
}

.plan {
  text-transform: capitalize;
}

.inActive {
  background-color: lightgray;
}
</style>
